<div class="TopSlider">
    <div class="slidesHolder">
        <div class="slides">

            <div class="slide" *ngFor="let item of topPromo">
                <!-- <a [routerLink]="item.url"> -->
                    <div class="plusHolder">
                        <div class="plusWrap">
                            <app-add-large [movie]="item.movie"></app-add-large>
    
                        </div>
                    </div>

                <img [src]="!isMobile ? item.img : item.imgMob" alt="">
                <video [src]="!isMobile? item.video : item.videoMob "
                    *ngIf="(!isMobile && item.video != '') || (isMobile && item.videoMob != '') " #videoEl
                    [poster]="!isMobile ? item.img : item.imgMob" [muted]="true" playsInline="true"
                    [autoplay]="isAutoplayVideo" [loop]="true" appVideoHandler (ended)="onVideoEnded($event)"></video>
                <!-- <div class="overlay"></div> -->
                <!-- </a> -->
                <div class="playPauseButton">
                    <app-video-play-pause-button *ngIf="videoEl != undefined && item.video != '' && item.video != undefined"
                        [data]="videoEl.toArray()[0]"></app-video-play-pause-button>
                </div>


                <div class="ttWrap" *ngIf="!isMinimal">

                    <div class="tt">
                        <div class="starring">{{item.starring}}</div>
                        <div class="title">{{item.title}}</div>

                        <div class="buttons">
                            <div class="roundButton white" (click)="onBookNow()">
                                <div class="label">
                                    Book Now
                                </div>
                            </div>

                            <a class="moreInfo" [routerLink]="item.url">
                                More Info
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

</div>